import { Box, Typography, List, ListItem, ListItemText } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next';

export default function ReferenceExport({ data }) {
  const {t} = useTranslation();

  // If we have the specific references data, display it in the desired format

  return (
    <Box sx={{ bgcolor: "#f9f9f9" }}>
      <Box
        key={1}
        id={`tlm-threat-1`}
        sx={{
          width: "210mm",
          margin: "auto",
          marginBottom: "20px",
          pageBreakAfter: "always",
          boxShadow: 3,
          borderRadius: 2,
          bgcolor: "#f9f9f9",
          padding: "20px",
          boxSizing: "border-box",
          overflow: "hidden",
        }}
      >
        {/* Main Title */}
        <Typography
          sx={{
            textAlign: "center",
            fontSize: { xs: "32px", sm: "40px" },
            fontWeight: "bold",
            marginBottom: "20px",
          }}
        >
          References
        </Typography>
        <List dense>
          {data?.map((item, index) => (
            <Box key={`${index}`} sx={{ mb: 3 }}>
                  <ListItem  sx={{ pl: 4 }}>
                    <ListItemText primary={`• ${item}`} />
                  </ListItem>
            </Box>
          ))}
        </List>
      </Box>
    </Box>
  )
}